// 肾功能：微量白蛋白、尿钙、肌酐、潜血、蛋白质
// 肝功能：胆红素、尿胆原、维生素
// 内分泌：尿糖、酮体
// 身体炎症：亚硝酸盐、白细胞
// 代谢循环：比重
// 酸碱平衡：酸碱度

export const diseaseList = [
  {
    text:'肾功能',
    id:0,
    list:[
      {subText:'微量白蛋白'},
      {subText:'尿钙'},
      {subText:'肌酐'},
      {subText:'潜血'},
      {subText:'蛋白质'}
    ]
  },
  {
    text:'肝功能',
    id:1,
    list:[
      {subText:'胆红素'},
      {subText:'尿胆原'},
      {subText:'维生素'}
    ]
  },
  {
    text:'内分泌',
    id:2,
    list:[
      {subText:'尿糖'},
      {subText:'酮体'}
    ]
  },
  {
    text:'身体炎症',
    id:3,
    list:[
      {subText:'亚硝酸盐'},
      {subText:'白细胞'}
    ]
  },
  {
    text:'代谢循环',
    id:4,
    list:[
      {subText:'比重'}
    ]
  },
  {
    text:'酸碱平衡',
    id:5,
    list:[
      {subText:'酸碱度'}
    ]
  }
]

export const shareList =[
  {subText:'肌酐'},
  {subText:'比重'},
  {subText:'尿钙'},
  {subText:'酸碱度'},
  {subText:'潜血'},
  {subText:'尿糖'},
  {subText:'酮体'},
  {subText:'维生素'},
  {subText:'尿胆原'},
  {subText:'胆红素'},
  {subText:'白细胞'},
  {subText:'蛋白质'},
  {subText:'亚硝酸盐'},
  {subText:'微量白蛋白'}
]

export const shareBlackList =[
  {
    subText:'肌酐',
    imgUrl:`creatinine.png`
  },
  { 
    subText:'比重',
    imgUrl:`proportion.png`
  },
  {subText:'尿钙',imgUrl:`uCa.png`},
  {subText:'潜血',imgUrl:`blood.png`},
  {subText:'尿糖',imgUrl: `sugar.png`},
  {subText:'酮体',imgUrl:`ketone.png`},
  {subText:'酸碱度',imgUrl:`pH.png`},
  {subText:'维生素',imgUrl:`vitamin.png`},
  {subText:'尿胆原',imgUrl:`urobilinogen.png`},
  {subText:'胆红素',imgUrl:`bilirubin.png`},
  {subText:'白细胞',imgUrl:`leukocyte.png`},
  {subText:'蛋白质',imgUrl:`protein.png`},
  {subText:'亚硝酸盐',imgUrl:`nitrite.png`},
  {subText:'微量白蛋白',imgUrl:`malb.png`}
]

export const levelCode={
  1:'正常',
  2:'异常',
  3:'请注意',
  4:'轻度异常',
  5: '重度异常',
  6: '偏高',
  7: '偏低',
  8: '偏酸',
  9: '偏碱',
  10: '较小干扰',
  11: '较大干扰',
  12: '干扰'
}

export const sexCode = {
  0: '未知',
  1: '男',
  2: '女',
}

export const disturbCode ={
  '0': '干扰',
  '1': '较小干扰',
}